import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";


export default function Footer() {
  const { settings, loading } = useSite();
  const logo = settings?.logo?.light;
  return (
    <footer className="bg-ink text-ivory">
      <div className="container-lux py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-1">
          {loading || !logo ? <span className="font-serif text-xl tracking-[0.18em]">BARIQUE</span> : <img src={logo} alt="BARIQUE" className="h-6" />}
          <p className="mt-6 text-xs text-ivory/50 tracking-wide max-w-xs">Contemporary Indian couture, hand-crafted in New Delhi.</p>
        </div>
        <FooterCol title="Collections" links={[
          ["Women", "/collections/women"], ["Menswear", "/collections/menswear"],
          ["Bridal", "/collections/bridal"], ["Festive", "/collections/festive"],
          ["Occasion", "/collections/cocktail"],
        ]}/>
        <FooterCol title="Customer Care" links={[
          ["Track Order", "/track"], ["Size Guide", "/about"], ["Contact", "/contact"],
        ]}/>
        <FooterCol title="The Maison" links={[
          ["About", "/about"], ["Journal", "/journal"],
        ]}/>
        <FooterCol title="Legal" links={[
          ["Terms & Conditions", "/terms"],
          ["Privacy Policy", "/privacy"],
        ]}/>
      </div>

      <div className="border-t border-ivory/10">
        <div className="container-lux py-8 flex flex-col md:flex-row items-center justify-between gap-4 text-[11px] tracking-[0.24em] uppercase text-ivory/40">
          <p>© 2026 BARIQUE Couture, New Delhi</p>
          <div className="flex gap-6">
            <a href="https://wa.me/919667245584" target="_blank" rel="noreferrer" className="hover:text-ivory">WhatsApp</a>
            <a href="mailto:bariquecouture@gmail.com" className="hover:text-ivory">Email</a>
            <a href="https://www.instagram.com/barique_couture/" target="_blank" rel="noreferrer" className="hover:text-ivory">Instagram</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="overline text-ivory/60">{title}</p>
      <ul className="mt-6 space-y-3">
        {links.map(([l, to]) => (
          <li key={l}><Link to={to} className="text-sm text-ivory/80 hover:text-ivory transition-colors">{l}</Link></li>
        ))}
      </ul>
    </div>
  );
}
